import Store from '@/ui/pages/Store';
import StoreInfo from '@/ui/pages/Store/StoreInfo';
import { useLocation } from 'react-router-dom';;

const StoreRouteHandler = () => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const findParam = queryParams.get('find');

    return findParam ? <Store /> : <StoreInfo />;
};

export default StoreRouteHandler;